module.exports = __webpack_public_path__ + "static/media/13.b3d84fbf.jpg";